import { makeStyles } from "tss-react/mui"
import {
  digitalClockClasses,
  multiSectionDigitalClockSectionClasses,
  pickersDayClasses,
  pickersMonthClasses,
  pickersYearClasses
} from "@mui/x-date-pickers"
import { blueGrey } from "../../../../mp-core/themes/palette"

export const useStyles = makeStyles<{ isInline: boolean }>()(
  (theme, { isInline }) => {
    const cellStates = {
      "&:hover": {
        backgroundColor: theme.palette.secondary[50]
      },
      "&:focus, &:focus-visible": {
        ...theme.mixins.focusRing.ring,
        backgroundColor: theme.palette.secondary[50]
      },
      "&.Mui-selected": {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.secondary[700],
        "&:hover": {
          backgroundColor: theme.palette.secondary[700]
        },
        "&:focus, &:focus-visible": {
          ...theme.mixins.focusRing.ring,
          backgroundColor: theme.palette.secondary[700]
        }
      }
    }

    return {
      input: {
        height: isInline ? "36px" : "52px"
      },
      datepickerIcon: {
        color: blueGrey[400]
      },
      pickerPopup: {
        [`& .${pickersDayClasses.root}`]: cellStates,
        [`& .${pickersYearClasses.yearButton}`]: cellStates,
        [`& .${pickersMonthClasses.monthButton}`]: cellStates,
        [`& .${digitalClockClasses.item}`]: cellStates,
        [`& .${multiSectionDigitalClockSectionClasses.item}`]: cellStates
      }
    }
  }
)
